"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloudChargerOperatingStatusValidation = void 0;
class CloudChargerOperatingStatusValidation {
    static isValid(entity) {
        // Validate entity.status_powernode_ChargerStatus_json for existence and correct type.
        if (entity.status_powernode_ChargerStatus_json == undefined)
            return false;
        if (typeof entity.status_powernode_ChargerStatus_json !== "string")
            return false;
        // If entity.organization_name exists, validate that it has the correct type.
        if (entity.organization_name != undefined) {
            if (typeof entity.organization_name !== "string")
                return false;
        }
        // If entity.membership_validation_charger_MembershipValidation_json exists, validate that it has the correct type.
        if (entity.membership_validation_charger_MembershipValidation_json !=
            undefined) {
            if (typeof entity.membership_validation_charger_MembershipValidation_json !==
                "string")
                return false;
        }
        return true;
    }
}
exports.CloudChargerOperatingStatusValidation = CloudChargerOperatingStatusValidation;
